import TargetDrag from './TargetDrag';
export { TargetDrag };
export default TargetDrag;
